import React, { useEffect, useState } from "react";
import Organization from "./Organization";
import AuthService from "../../../../base/services/authentication.service";
import { httpService } from "../../../../base/services/httpService.service";
import { Spin } from "antd";
import { withErrorBoundary } from "../../../../components/ErrorBoundary/withErrorBoundary";
import {
   getStoredBillingStatus,
   isBillingManaged,
   useBillingStore
} from "../../../../components/Billing/billingStore";
import { isOrganizationLocked } from "../../../../components/Billing/billingSignIn";
import { describeOrganizationLock } from "../../../../components/Billing/billingCodes";

// An organization without a valid subscription used to be a dead end, shown as
// deactivated. With the new billing flow it is one to open for whoever may pay
// for it: selecting it lands on its billing page, which is where it gets a
// subscription back.
const isUnavailable = (item) =>
   item.isDeletedOrg || (!item.hasValidSubscription && !isBillingManaged(item.organizationId));

// Anybody else is kept out of it, and its card says why (billingSignIn.js).
const describeLock = (item) =>
   isOrganizationLocked(item)
      ? describeOrganizationLock(
           getStoredBillingStatus(item.organizationId)?.reason,
           item.organizationName
        )
      : null;

const Organizations = () => {
   const userId = AuthService.getUser()?.id;
   // The cards are drawn from the stored statuses and from what
   // selectOrganization said, which change as an organization is tried.
   useBillingStore((state) => state.statuses);
   useBillingStore((state) => state.gateHolds);
   useBillingStore((state) => state.billingRights);
   useBillingStore((state) => state.canManageBilling);

   const [organizations, setOrganizations] = useState([]);
   const [isLoading, setIsLoading] = useState(false);

   useEffect(() => {
      setIsLoading(true);
      httpService
         .get(
            `/Account/getUserOrganizations?userId=${userId}`,
            (response) => {
               setOrganizations(response.data);
            },
            (error) => {
               console.log("error:", error);
            }
         )
         .finally(() => {
            setIsLoading(false);
         });
   }, [userId]);

   return (
      <>
         {isLoading ? (
            <Spin
               style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "50px"
               }}
            ></Spin>
         ) : (
            <div className="allOrganizations">
               {organizations?.map((item) => (
                  <Organization
                     organizationId={item.organizationId}
                     organizationName={item.organizationName}
                     organizationMemberId={item.organizationMemberId}
                     key={item.organizationId}
                     isDeactivatedUser={item.isDeletedUser}
                     isDeactivatedOrganization={isUnavailable(item)}
                     lock={describeLock(item)}
                  />
               ))}
            </div>
         )}
      </>
   );
};

export default withErrorBoundary(Organizations);
